/***
 * Created on 2023/12/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useState} from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {getErrorMessage} from 'common/ServiceCommon';
import {useOnChange} from "../../../hook/form";
import {apiPost} from "../../../service/api";
import {useCountdown} from "../../common/countdown";

function VerifyEmailDialog({state, dispatch, ...props}) {
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState();
    const {seconds, setSeconds} = useCountdown(60);
    const {values, setValues, onChange} = useOnChange({
        code: ''
    });

    const updateMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/email', data),
        onSuccess: data => {
            dispatch({type: 'showSigninAgain', value: true});
        },
        onError: (error, variables, context) => {
            setErrorMessage(getErrorMessage(t, error.cause?.code));
        }
    });

    const onVerify = () => {
        updateMutation.mutate(values);
    }

    return (
        <ModalDialog {...props} title={t('@Change Email@')} submitAction={onVerify}>
            <div className="dialog-content">
                <p className="!mb-16">
                    {t('@We have sent a confirmation email with a verification code to {{new_email}}. Enter the code:@', {new_email: state.new_email})}
                </p>
                <div className="dialog__form-group">
                    <div className="comp-input">
                        <div className="input-field--hybrid">
                            <input type="text" className="input--must-fill" onChange={onChange} name="code" value={values.code}/>
                            <button className="q-btn q-btn-default" disabled={seconds > 0}>{seconds > 0 ? `${seconds} sec` : t("@Resend@")}</button>
                        </div>
                    </div>
                </div>
                {errorMessage && <p className="text-error hide">{errorMessage}</p>}
            </div>
        </ModalDialog>
    );
}

export default VerifyEmailDialog;